import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import React, { useState } from 'react';
import { RegionsSettingsComponent } from '../components/RegionsSettingsComponent/RegionsSettingsComponent';
import { LevelsManagementComponent } from '../components/LevelsManagementComponent/LevelsManagementComponent';
import EnergyManagementComponent from '../components/EnergyManagementComponent/EnergyManagementComponent';

export const AppSettings = () => {
  const [alignment, setAlignment] = useState('region');
  const [activeTab, setActiveTab] = useState('region');
  
  return (
    <div>
      <ToggleButtonGroup
        color="primary"
        key={alignment}
        value={alignment}
        defaultValue={'region'}
        defaultChecked={true}
        exclusive
        onChange={(event: React.MouseEvent<HTMLElement>, newAlignment: string) => setAlignment(newAlignment)}
        aria-label="Platform"
        className="mt-5"
      >
        <ToggleButton onClick={() => setActiveTab('region')} value="region">Region management</ToggleButton>
        <ToggleButton onClick={() => setActiveTab('levels')} value="levels">Levels management</ToggleButton>
        <ToggleButton onClick={() => setActiveTab('energy')} value="energy">Energy management</ToggleButton>
      </ToggleButtonGroup>
      <div>
        {activeTab === 'region' && <RegionsSettingsComponent />}
        {activeTab === 'levels' && <LevelsManagementComponent />}
        {activeTab === 'energy' && <EnergyManagementComponent />}
      </div>
    </div>
  )
}